import {
  SUMMARY_DATA_LOADING,
  SUMMARY_DATA_SUCCESS,
  CALLSPAGE_QUICKFILTER_DATA_SUCCESS,
  SET_ALL_FILTERS,
  CALLS_PAGE_POLLING_STARTED,
  CALLS_PAGE_POLLING_COMPLETED,
  CALLS_PAGE_POLLING_FAILED,
  CALLS_PAGE_POLLING_RESET,
  CALLS_GEO_TIN_COUNT_DATA_LOADING,
  CALLS_GEO_TIN_COUNT_DATA_SUCCESS,
} from '@src/middleware/actions/actionTypes';
import {
  CALLTYPE_DATA_SUCCESS,
  CALLTYPE_DATA_ERROR,
  CALLTYPE_DATA_LOADING,
} from '@src/middleware/actions/actionTypes';
import {
  CALLMONTH_DATA_LOADING,
  CALLMONTH_DATA_SUCCESS,
} from '@src/middleware/actions/actionTypes';

interface CallPageState {
  summaryData: any;
  isSearchLoading: boolean;
  isSummaryDataError: boolean;
  summaryDataError?: any;
  quickFilterTinData: any;
  loadingCallType: boolean;
  loadingCallMonth: boolean;
  callTypeData: any;
  callMonthData: any;
  timePeriod: any;
  lineOfBusiness: any;
  taxId: any[];
  contractId: any[];
  region: any;
  state: any[];
  market: any[];
  activeChipTins: any[] | null; // For chip click filtering (null = all TINs, array = specific TINs)
  pollingCount: number;
  pollingError: any;
  tinCountDataLoading: boolean;
  tinCountData: any;
}

const initialState: CallPageState = {
  summaryData: {},
  isSearchLoading: true,
  isSummaryDataError: false,
  summaryDataError: null,
  quickFilterTinData: [],
  loadingCallType: true,
  loadingCallMonth: true,
  callTypeData: {},
  callMonthData: [],
  timePeriod: null,
  lineOfBusiness: null,
  taxId: [],
  contractId: [],
  region: null,
  state: [],
  market: [],
  activeChipTins: null, // null = use all TINs from taxId
  pollingCount: 0,
  pollingError: null,
  tinCountData: null,
  tinCountDataLoading: true,
};

const areArraysEqual = (arr1: any[], arr2: any[]): boolean => {
  if (arr1 === arr2) return true;
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;

  return JSON.stringify(arr1) === JSON.stringify(arr2);
};

const CallsPageReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): CallPageState => {
  switch (action.type) {
    case SUMMARY_DATA_LOADING: {
      return {
        ...state,
        isSearchLoading: action.payload,
      };
    }

    case SUMMARY_DATA_SUCCESS: {
      return {
        ...state,
        summaryData: action.payload?.initialData,
      };
    }

    case CALLSPAGE_QUICKFILTER_DATA_SUCCESS:
      return {
        ...state,
        quickFilterTinData: action.payload,
      };

    case CALLTYPE_DATA_LOADING: {
      return {
        ...state,
        loadingCallType: action.payload,
      };
    }

    case CALLTYPE_DATA_SUCCESS: {
      return {
        ...state,
        callTypeData: action.payload,
      };
    }

    case CALLMONTH_DATA_LOADING: {
      return {
        ...state,
        loadingCallMonth: action.payload,
      };
    }

    case CALLMONTH_DATA_SUCCESS: {
      return {
        ...state,
        callMonthData: action.payload,
      };
    }

    case CALLS_GEO_TIN_COUNT_DATA_LOADING: {
       return {
        ...state,
        tinCountDataLoading: action.payload,
       }
    }

    case CALLS_GEO_TIN_COUNT_DATA_SUCCESS: {
       return {
        ...state,
        tinCountData: action.payload,
       }
    }

    case CALLS_PAGE_POLLING_STARTED: {
      return {
        ...state,
        pollingCount: state.pollingCount + 1,
        pollingError: null,
      };
    }

    case CALLS_PAGE_POLLING_COMPLETED:
      return {
        ...state,
        pollingCount: Math.max(0, state.pollingCount - 1),
        pollingError: null,
      };

    case CALLS_PAGE_POLLING_FAILED:
      return {
        ...state,
        pollingCount: Math.max(0, state.pollingCount - 1),
        pollingError: action.payload,
      };

    case CALLS_PAGE_POLLING_RESET:
      return {
        ...state,
        pollingCount: 0,
        pollingError: null,
      };

    case SET_ALL_FILTERS: {
      const newTimePeriod =
        action.payload.timePeriod !== undefined
          ? action.payload.timePeriod
          : state.timePeriod;
      const newLob =
        action.payload.lineOfBusiness !== undefined
          ? action.payload.lineOfBusiness
          : state.lineOfBusiness;
      const newTaxIds =
        action.payload.taxId !== undefined ? action.payload.taxId : state.taxId;
      const newContractIds =
        action.payload.contractId !== undefined ? action.payload.contractId : state.contractId;
      const newRegion =
        action.payload.region !== undefined
          ? action.payload.region
          : state.region;
      const newState =
        action.payload.state !== undefined ? action.payload.state : state.state;
      const newMarket =
        action.payload.market !== undefined
          ? action.payload.market
          : state.market;
      const newActiveChipTins =
        action.payload.activeChipTins !== undefined
          ? action.payload.activeChipTins
          : state.activeChipTins;

      const timePeriodUnchanged = newTimePeriod === state.timePeriod;
      const lobUnchanged = newLob === state.lineOfBusiness;
      const taxIdsUnchanged = areArraysEqual(newTaxIds, state.taxId);
      const contractIdsUnchanged = areArraysEqual(newContractIds, state.contractId);
      const regionUnchanged = newRegion === state.region;
      const stateUnchanged = areArraysEqual(newState, state.state);
      const marketUnchanged = areArraysEqual(newMarket, state.market);
      const activeChipTinsUnchanged =
        newActiveChipTins === state.activeChipTins ||
        (Array.isArray(newActiveChipTins) &&
          Array.isArray(state.activeChipTins) &&
          areArraysEqual(newActiveChipTins, state.activeChipTins));

      if (
        timePeriodUnchanged &&
        lobUnchanged &&
        taxIdsUnchanged &&
        contractIdsUnchanged &&
        regionUnchanged &&
        stateUnchanged &&
        marketUnchanged &&
        activeChipTinsUnchanged
      ) {
        return state;
      }

      return {
        ...state,
        timePeriod: newTimePeriod,
        lineOfBusiness: newLob,
        taxId: newTaxIds,
        contractId: newContractIds,
        region: newRegion,
        state: newState,
        market: newMarket,
        activeChipTins: newActiveChipTins,
      };
    }

    default:
      return state;
  }
};

export default CallsPageReducer;